<div class="card-header-mini mb-0">
  <h3 class="card-title">{{widgetData.title}}</h3>
  <a *ngIf="widgetData.allLinkUrl" href="{{widgetData.allLinkUrl}}" target="{{widgetData.allLinkTarget}}" class="more-link">{{widgetData.allLinkText}}</a>
</div>

<mat-table *ngIf="requests.length && !loading && !isServerError" [dataSource]="requests">
  <ng-container matColumnDef="text">
    <mat-cell *matCellDef="let element" class="title-td">
      <div>
        {{ element.title }}

        <div class="d-not-phone-none">
          <ng-container [ngSwitch]="element.state">
            <ng-container *ngSwitchCase="RequestState.Completed" [ngTemplateOutlet]="completedStateLabel"></ng-container>
            <ng-container *ngSwitchCase="RequestState.Active" [ngTemplateOutlet]="activeStateLabel"></ng-container>
            <!-- add more cases for all possible states -->
          </ng-container>
        </div>
      </div>
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="state">
    <mat-cell *matCellDef="let element" class="justify-content-center state-td fs-14 d-phone-none">
      <ng-container [ngSwitch]="element.state">
        <ng-container *ngSwitchCase="RequestState.Completed" [ngTemplateOutlet]="completedStateLabel"></ng-container>
        <ng-container *ngSwitchCase="RequestState.Active" [ngTemplateOutlet]="activeStateLabel"></ng-container>
        <!-- add more cases for all possible states -->
      </ng-container>
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="date">
    <mat-cell *matCellDef="let element" class="justify-content-end date-td">
      <div class="fs-14">
        {{ element.date | date: 'shortDate' }}
      </div>
    </mat-cell>
  </ng-container>

  <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
</mat-table>

<ng-container *ngIf="!requests.length && !loading && !isServerError">
  <div>{{widgetData.noRequestsAndProcessesText}}</div>
  <a *ngIf="widgetData.noRequestsAndProcessesLink" href="{{widgetData.noRequestsAndProcessesLink}}" target="_blank">{{widgetData.noRequestsAndProcessesLinkText}}</a>
</ng-container>

<mat-table *ngIf="loading && !isServerError" [dataSource]="requests">
  <ng-container matColumnDef="text">
    <mat-cell *matCellDef="let element" class="title-td">
      <div>
        <app-skeleton [type]="'text'" [symbolsCount]="20"/>

        <div class="d-not-phone-none">
          <app-skeleton [height]="30" [width]="60" [borderRadius]="'2.5rem'"/>
        </div>
      </div>
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="state">
    <mat-cell *matCellDef="let element" class="justify-content-center state-td fs-14 d-phone-none">
      <app-skeleton [height]="30" [width]="60" [borderRadius]="'2.5rem'"/>
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="date">
    <mat-cell *matCellDef="let element" class="justify-content-end date-td">
      <app-skeleton class="fs-14" [type]="'text'" [symbolsCount]="8"/>
    </mat-cell>
  </ng-container>

  <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
</mat-table>

<app-timeout-error-message *ngIf="isServerError"></app-timeout-error-message>

<ng-template #completedStateLabel>
  <div class="badge primary-green">
    {{widgetData.completedStatusLabelText}}
  </div>
</ng-template>

<ng-template #activeStateLabel> 
  <div class="badge primary-blue">
    {{widgetData.activeStatusLabelText}}
  </div>
</ng-template>

<!-- add more templates for all possible states -->